import { createArray } from '~logic/helpers/arrayUtils/createArray'
import { TProductDetailState } from '~logic/xstate/machines/menu/productDetailMachineTypes'

type TAddonCategory = TProductDetailState['addonCategories'][number]
type TAddon = TAddonCategory['addons'][number]

const getPlaceholderAddons = (itemCount: number) => {
  const placeholderItems: RoA<TAddon> = createArray({
    length: itemCount,
    mappingFunction: (index): TAddon => ({
      amount: 0,
      id: `${index}`,
      nameLabel: `name label placeholder`,
      isMainProduct: Math.random() < 0.15,
      price: { value: 0, formattedValue: `0 CZK` },
    }),
  })

  return placeholderItems
}

/**
 * Generates fake addon categories populated with fake items with the same structure as the real data
 * that can be used to render categories with loading skeletons before the data arrives.
 * @param categoryItemCounts Array of lengths of addon categories, each value represents one addon category and determines how many addons it will contain.
 *
 */
export const getAddonListPlaceholders = (categoryItemCounts: RoA<number>) => {
  const placeholders: RoA<TAddonCategory> = categoryItemCounts.map((categoryLength, index) => {
    return {
      id: `${index}`,
      nameLabel: `name label placeholder`,
      // all placeholder categories are mandatory,
      //they show validation message placeholder
      //and there is no "additional addons" heading
      minTotalCount: 1,
      // ! skeletons are set only for AddAmountButtons,
      // ! therefore maxIndividualCount must be greater then 1 && maxTotalCount >= 2
      maxTotalCount: 2,
      maxIndividualCount: 2,
      addons: getPlaceholderAddons(categoryLength),
    }
  })

  return placeholders
}
